import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import {
  FORNECEDOR_ENDPOINT,
} from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    FORNECEDOR_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    FORNECEDOR_ENDPOINT,
    id,
  ]);
}

export async function changeFavorecidoImpostos() {
  return doPutQCXRequest([
    FORNECEDOR_ENDPOINT,
    'favorecido-impostos',
  ]);
}

export async function register(data, queryParams = []) {
  return doPostQCXRequest(
    [FORNECEDOR_ENDPOINT],
    data,
    queryParams
  );
}

export async function save(data, queryParams = []) {
  return doPutQCXRequest(
    [FORNECEDOR_ENDPOINT],
    data,
    queryParams
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [FORNECEDOR_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [FORNECEDOR_ENDPOINT],
    id
  );
}
